<template>
	<div>
		<Calendar
			class="availability-calendar"
			context="availability"
			:availabilities="true"
			:jobs="true"
			:user="user"
			v-bind="$attrs"
			v-on="$listeners"
			@date:click="onDateClick"
		>
		</Calendar>
		
		<AvailabilityEditModal v-model="showA10yEditModal" context="single"/>
		
		<Modal v-model="showJobListModal">
			<template #title>{{ formatDate(selectedDates[0].timestamp) }}</template>
			<template #content>
				<div class="grid gap-8">
					<div v-for="job in selectedDates[0].jobs" :key="job.id" class="border pad-16 hover-bc-blue cursor-pointer" @click="toJob(job.id)">
						<div class="color-violet fs-16 lh-20 fw-700">{{ job.event.name }}</div>
						<div v-if="job.positionId" class="fs-14 mt-4">{{ getRoleFromId(job.positionId).name }}</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import Calendar from '@/components/calendars/Calendar';
import helpers from '@/mixins/helpers';
import AvailabilityEditModal from '@/components/availability/AvailabilityEditModal';

export default {
	name: 'AvailabilityCalendar',
	components: {
		Calendar,
		AvailabilityEditModal,
	},
	inheritAttrs: false,
	mixins: [helpers],
	props: {
		user: {
			default: null,
		},
	},
	data() {
		return {
			availability: null,
			jobs: null,
			selectedDate: null,
			showA10yEditModal: false,
			showJobListModal: false,
		};
	},
	computed: {
		selectedDates() {
			return this.$store.getters['availability/selectedDates'];
		},
	},
	methods: {
		onDateClick(date) {
			this.$store.commit('availability/toggleSelectedDate', date);

			if (date.jobs.length > 1) {
				this.showJobListModal = true;
			} else if (date.jobs.length) {
				this.toJob(date.jobs[0].id);
			} else if (!this.isStudio) {
				this.$store.commit('availability/setSelectedDateData', date.availabilities);
				this.showA10yEditModal = true;
			}
		},
		toJob(id) {
			this.$store.commit('availability/clearSelectedDates');
			this.$router.push({
				name: this.$routes.JobDetails.name,
				params: {
					jobId: id
				}
			});
		},
	},
	watch: {
		showJobListModal() {
			if (!this.showJobListModal) {
				this.$store.commit('availability/clearSelectedDates');
			}
		},
	},
};
</script>
